import { motion } from "framer-motion";

export const PageHero = ({ overline, title, image, children }) => (
  <section
    className="relative pt-36 pb-16 md:pt-48 md:pb-24 bg-[#0A1F16] grain-overlay overflow-hidden"
    data-testid={`page-hero-${overline.toLowerCase().replace(/[^a-z]+/g, "-")}`}
  >
    {image && (
      <div className="absolute inset-0">
        <img src={image} alt="" className="w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-[#0A1F16]/55" />
      </div>
    )}
    <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-xs md:text-sm uppercase tracking-[0.3em] font-semibold text-[#BFA26F] mb-5"
      >
        {overline}
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className="font-display text-4xl md:text-5xl lg:text-6xl font-medium text-[#FBF9F6] max-w-4xl leading-[1.1]"
      >
        {title}
      </motion.h1>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.7, delay: 0.2 }}
        className="mt-7 h-px w-24 bg-[#BFA26F]"
      />
      {children && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="mt-8 space-y-4 text-base md:text-lg font-light text-[#FBF9F6]/75 max-w-3xl leading-relaxed"
        >
          {children}
        </motion.div>
      )}
    </div>
  </section>
);
